import { CountriesPhone, CountriesPhoneList } from 'shared/constants/countries'
import { IPhoneInput } from 'shared/ui/phone-input'

export const preparePhoneNumber = (phoneNumber?: string) => {
  if (!phoneNumber) {
    return {
      code: CountriesPhone.KG.code,
      phone: '',
    }
  }

  const foundCountry = CountriesPhoneList.find((country) =>
    phoneNumber.startsWith(country.dial_code),
  )

  if (!foundCountry) {
    return {
      code: CountriesPhone.KG.code,
      phone: phoneNumber,
    }
  }

  return {
    code: foundCountry.code,
    phone: phoneNumber.replace(foundCountry.dial_code, ''),
  }
}

export const preparePhoneNumberForRequest = (phoneNumber?: IPhoneInput) => {
  if (!phoneNumber) return null

  const code =
    CountriesPhone?.[phoneNumber?.code as keyof typeof CountriesPhone]
      ?.dial_code

  return `${code}${phoneNumber.phone}`
}
